export const QUIZ_QUESTIONS = [
  {
    id: "q1_gpu_count",
    title: "Сколько GPU в вашей инфраструктуре?",
    options: [
      { label: "До 32", score: 2 },
      { label: "32–128", score: 5 },
      { label: "128–512", score: 8 },
      { label: "512+", score: 10 },
    ],
  },
  {
    id: "q2_utilization",
    title: "Какова средняя утилизация GPU?",
    options: [
      { label: "До 25%", score: 10 },
      { label: "25–45%", score: 8 },
      { label: "45–65%", score: 5 },
      { label: "65%+", score: 2 },
    ],
  },
  {
    id: "q3_workload",
    title: "Преобладающий тип нагрузки",
    options: [
      { label: "Обучение крупных моделей", score: 8 },
      { label: "Инференс в проде", score: 8 },
      { label: "Смешанная (training + inference)", score: 10 },
      { label: "R&D / эксперименты", score: 5 },
    ],
  },
  {
    id: "q4_scheduler",
    title: "Что используется как планировщик?",
    options: [
      { label: "Стандартный K8s scheduler", score: 10 },
      { label: "Kueue / Volcano", score: 6 },
      { label: "SLURM / собственное решение", score: 7 },
      { label: "Не уверен(а)", score: 5 },
    ],
  },
  {
    id: "q5_pain",
    title: "Главная боль инфраструктуры",
    options: [
      { label: "Простой GPU и высокий TCO", score: 10 },
      { label: "Фрагментация ресурсов", score: 9 },
      { label: "Очереди задач и SLA", score: 8 },
      { label: "Отсутствие FinOps-контроля", score: 7 },
    ],
  },
];
